import { render } from "./BorderBtn.vue?vue&type=template&id=ae6cb9f6"
import script from "./BorderBtn.vue?vue&type=script&lang=js"
export * from "./BorderBtn.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BorderBtn.vue?vue&type=style&index=0&id=ae6cb9f6&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/musubisumu/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__